import React from "react";
import { IconX } from "@tabler/icons-react";
import SubmitButton from "./SubmitButton";

type Props = {
  closeButtonText?: string;
  actionButtonOnClick?: () => void;
  actionButtonText?: string;
  onClose: () => void;
  title: string;
  // subtitle?: string;
   subtitle?: React.ReactNode; // Changed from string | undefined
  open: boolean;
  img: string;
  showFooter?: boolean;
  size?: "sm" | "md" | "lg";
  isPending?: boolean;
};

const MessageModal = ({
  open,
  onClose,
  title,
  subtitle,
  img,
  actionButtonOnClick,
  closeButtonText = "Cancel",
  actionButtonText = "Confirm",
  showFooter = true,
  size = "md",
  isPending
}: Props) => {
  if (!open) return null;

  const sizeClasses = {
    sm: "max-w-sm",
    md: "max-w-lg",
    lg: "max-w-xl",
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4 py-6">
      {/* Modal Box */}
      <div
        className={`relative w-full rounded-2xl bg-white shadow-xl ${sizeClasses[size]}`}
      >
        {/* Close Button */}
        {/* <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full p-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400"
        >
          <IconX size={20} />
        </button> */}

        {/* Modal Content */}
        <div className="flex flex-col items-center px-6 py-10 text-center">
          {/* Image Icon */}
          <div className="mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-yellow-100">
            <img src={img} alt={title} className="h-12 w-12 object-contain" />
          </div>

          {/* Title */}
          <h2 className="text-2xl font-semibold text-gray-800">{title}</h2>

          {/* Subtitle */}
          {subtitle && (
            <p className="mt-2 text-gray-600 text-sm leading-6">{subtitle}</p>
          )}

          {/* Footer */}
          {showFooter && (
            <div className="mt-8 flex w-full flex-col-reverse gap-3 sm:flex-row sm:justify-center sm:gap-4">
              <button
                onClick={onClose}
                className="w-full sm:w-auto rounded-full border border-gray-300 bg-white px-6 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 transition"
              >
                {closeButtonText}
              </button>
             
              <SubmitButton
                onClick={actionButtonOnClick}
                isPending={isPending}
                type="button"
              >
                {actionButtonText}
              </SubmitButton>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MessageModal;
